import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const CommercialPage = lazy(() => import('../pages/commercial/page'));
const AllProjectsPage = lazy(() => import('../pages/projects/all/page'));
const CompletedProjectsPage = lazy(() => import('../pages/projects/completed/page'));
const ProjectDetailPage = lazy(() => import('../pages/project-detail/page'));
const DiasporaInvestmentPage = lazy(() => import('../pages/diaspora-investment/page'));
const BlogsPage = lazy(() => import('../pages/blogs/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const DiasporaForumPage = lazy(() => import('../pages/diaspora-forum/page'));
const InvestmentCalculatorPage = lazy(() => import('../pages/investment-calculator/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/aboutus',
    element: <AboutPage />,
  },
  {
    path: '/projects/Ongoing',
    element: <ProjectsPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/projects/all',
    element: <AllProjectsPage />,
  },
  {
    path: '/projects/completed',
    element: <CompletedProjectsPage />,
  },
  {
    path: '/project/:slug',
    element: <ProjectDetailPage />,
  },
  {
    path: '/type/commercial',
    element: <CommercialPage />,
  },
  {
    path: '/diaspora-investment',
    element: <DiasporaInvestmentPage />,
  },
  {
    path: '/blogs',
    element: <BlogsPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/diaspora-forum',
    element: <DiasporaForumPage />,
  },
  {
    path: '/investment-calculator',
    element: <InvestmentCalculatorPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
